import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchCompetenciesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchCompetencies`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getCompetencies();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch competencies. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
